/**
 * Validation helpers for client form fields (arr, health_score).
 */

export function parseArr(value: string | undefined): number | null {
  if (!value || !value.trim()) return null;
  const n = parseFloat(value);
  if (Number.isNaN(n)) return null;
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

export function parseHealthScore(value: string | undefined): number | null {
  if (!value || !value.trim()) return null;
  const n = parseInt(value, 10);
  if (Number.isNaN(n)) return null;
  if (n < 0 || n > 100) return null;
  return n;
}

export function validateClientNumericFields(arr: string | undefined, healthScore: string | undefined): { arr: number | null; health_score: number | null; error?: string } {
  const parsedArr = parseArr(arr);
  const parsedHealth = parseHealthScore(healthScore);

  if (arr?.trim() && parsedArr === null) {
    return { arr: null, health_score: parsedHealth, error: 'ARR must be a valid non-negative number' };
  }
  if (healthScore?.trim() && parsedHealth === null) {
    return { arr: parsedArr, health_score: null, error: 'Health score must be between 0 and 100' };
  }

  return { arr: parsedArr, health_score: parsedHealth };
}
